import React from 'react';
import aboutImage from '../assets/images/utils/bg-your-trip-2.jpeg';

const About = () => {
    return (
        <div className="section container">
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '4rem',
                padding: '2rem 0'
            }}>
                <div style={{ textAlign: 'center', maxWidth: '800px', margin: '0 auto' }}>
                    <h1 style={{ fontSize: '3rem', marginBottom: '2rem', color: '#1e293b' }}>Qui Sommes-Nous ?</h1>
                </div>

                <div style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: '4rem',
                    alignItems: 'center'
                }} className="about-content">

                    {/* Image Section */}
                    <div>
                        <img
                            src={aboutImage}
                            alt="Equipe 2ATP-MR"
                            style={{
                                width: '100%',
                                borderRadius: '12px',
                                boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                                objectFit: 'cover',
                                height: '500px'
                            }}
                        />
                    </div>

                    {/* Text Section */}
                    <div style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#334155' }}>
                        <p style={{ marginBottom: '1.5rem' }}>
                            Implantée aux Mureaux depuis plus de 20 ans, <strong>2ATP-MR</strong> est une société spécialisée dans le transport de personnes, reconnue pour son professionnalisme et la qualité constante de ses prestations. Notre longue expérience nous a permis de construire une solide réputation et de gagner la confiance d’une clientèle fidèle, composée aussi bien de particuliers que de professionnels.
                        </p>
                        <p style={{ marginBottom: '1.5rem' }}>
                            Dès nos débuts, nous avons mis un point d’orgue à offrir un service fiable, confortable et adapté à chaque besoin. Qu’il s’agisse de trajets médicaux, de déplacements privés, de transports scolaires ou d’accompagnement de personnes à mobilité réduite, nous nous engageons à répondre aux attentes de nos clients avec ponctualité, sécurité et courtoisie.
                        </p>
                        <p>
                            Conscients des besoins spécifiques des familles, nous mettons également à disposition des sièges auto et réhausseurs pour enfants. Basés aux Mureaux, nous connaissons parfaitement notre secteur et ses alentours, garantissant des trajets optimisés. Nos chauffeurs, soigneusement sélectionnés et formés, partagent une vision commune : mettre leur savoir-faire au profit de chaque voyageur.
                        </p>
                    </div>
                </div>
            </div>

            {/* Mobile Responsive Styles */}
            <style>{`
                @media (max-width: 960px) {
                    .about-content {
                        grid-template-columns: 1fr !important;
                        gap: 2rem !important;
                    }
                }
            `}</style>
        </div>
    );
};

export default About;
